import { useEffect, useState } from "react";
import { api } from "./api";

// Simple module-level cache so we hit /vendedores once per page load.
let cache = null;
let inflight = null;
const listeners = new Set();

function notify() { listeners.forEach((fn) => fn(cache)); }

async function loadVendors() {
    if (cache) return cache;
    if (!inflight) {
        inflight = api.get("/vendedores")
            .then(({ data }) => {
                cache = Array.isArray(data) ? data : [];
                notify();
                return cache;
            })
            .catch(() => { cache = []; notify(); return cache; })
            .finally(() => { inflight = null; });
    }
    return inflight;
}

export function useVendor(vendorId) {
    const [vendor, setVendor] = useState(() => {
        if (!vendorId || !cache) return null;
        return cache.find((v) => v.id === vendorId) || null;
    });

    useEffect(() => {
        if (!vendorId) return;
        let mounted = true;
        const update = (list) => {
            if (!mounted || !list) return;
            setVendor(list.find((v) => v.id === vendorId) || null);
        };
        listeners.add(update);
        loadVendors().then(update);
        return () => { mounted = false; listeners.delete(update); };
    }, [vendorId]);

    return vendor;
}
